// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: manual_task.proto

export const protobufPackage = 'compasspb';

/** ManualTaskType represents the type of manual task. */
export enum ManualTaskType {
  MANUAL_TASK_TYPE_UNSPECIFIED = 0,
  /** MANUAL_TASK_TYPE_FILL_MISSING_INFO - Collect missing patient/insurance/pharmacy information */
  MANUAL_TASK_TYPE_FILL_MISSING_INFO = 1,
  /** MANUAL_TASK_TYPE_CALL - Make phone call for verification */
  MANUAL_TASK_TYPE_CALL = 2,
  /** MANUAL_TASK_TYPE_AUDIT - Review and approve/reject verification results */
  MANUAL_TASK_TYPE_AUDIT = 3,
  /** MANUAL_TASK_TYPE_ELIGIBILITY_CHECK_AUDIT - Review eligibility check results */
  MANUAL_TASK_TYPE_ELIGIBILITY_CHECK_AUDIT = 5,
  /** MANUAL_TASK_TYPE_INTAKE_DRAFT - Complete PQC intake form */
  MANUAL_TASK_TYPE_INTAKE_DRAFT = 6,
  /** MANUAL_TASK_TYPE_REVIEW - Review product quality complaint */
  MANUAL_TASK_TYPE_REVIEW = 7,
  /** MANUAL_TASK_TYPE_EMAIL_EXCHANGE - Handle email correspondence for PQC */
  MANUAL_TASK_TYPE_EMAIL_EXCHANGE = 8,
  /** MANUAL_TASK_TYPE_AWAITING_REVIEW - Review case for adverse event classification */
  MANUAL_TASK_TYPE_AWAITING_REVIEW = 9,
  /** MANUAL_TASK_TYPE_RESEND_EMAIL - Resend form email to manufacturer */
  MANUAL_TASK_TYPE_RESEND_EMAIL = 10,
  /** MANUAL_TASK_TYPE_ATTACH_TO_CASE - Attach a call to a case */
  MANUAL_TASK_TYPE_ATTACH_TO_CASE = 11,
  /** MANUAL_TASK_TYPE_REGENERATE_CASE_SUMMARY - Regenerate AI-generated case summary */
  MANUAL_TASK_TYPE_REGENERATE_CASE_SUMMARY = 12,
  /** MANUAL_TASK_TYPE_SCHEDULE_AI_CALL - Schedule an AI call for the case */
  MANUAL_TASK_TYPE_SCHEDULE_AI_CALL = 13,
  /** MANUAL_TASK_TYPE_EHR_UPDATE_INFORMATION - Update EHR information for the patient */
  MANUAL_TASK_TYPE_EHR_UPDATE_INFORMATION = 14,
  /** MANUAL_TASK_TYPE_EHR_CREATE_PATIENT_RECALL_HISTORY - Create patient recall history entry in EHR */
  MANUAL_TASK_TYPE_EHR_CREATE_PATIENT_RECALL_HISTORY = 15,
  /** MANUAL_TASK_TYPE_EHR_CREATE_PATIENT_OPEN_ACCESS_SCREENING - Create patient open access screening entry in EHR */
  MANUAL_TASK_TYPE_EHR_CREATE_PATIENT_OPEN_ACCESS_SCREENING = 16,
  /** MANUAL_TASK_TYPE_EHR_CREATE_PATIENT_NON_VISIT_ORDER - Create patient non-visit order in EHR */
  MANUAL_TASK_TYPE_EHR_CREATE_PATIENT_NON_VISIT_ORDER = 17,
  /** MANUAL_TASK_TYPE_SEND_EMAIL - Send email for the case */
  MANUAL_TASK_TYPE_SEND_EMAIL = 18,
  /** MANUAL_TASK_TYPE_SEND_TEXT - Send text message for the case */
  MANUAL_TASK_TYPE_SEND_TEXT = 19,
  /** MANUAL_TASK_TYPE_OFFICE_VISIT_SCHEDULE_VERIFICATION - Verify office visit scheduling */
  MANUAL_TASK_TYPE_OFFICE_VISIT_SCHEDULE_VERIFICATION = 20,
  /** MANUAL_TASK_TYPE_EHR_CREATE_PHARMACY_TASK - Create pharmacy task in EHR */
  MANUAL_TASK_TYPE_EHR_CREATE_PHARMACY_TASK = 21,
  /** MANUAL_TASK_TYPE_EHR_CREATE_SCHEDULING_HANDOFF_TASK - Create scheduling handoff task in EHR */
  MANUAL_TASK_TYPE_EHR_CREATE_SCHEDULING_HANDOFF_TASK = 22,
  /** MANUAL_TASK_TYPE_EHR_CREATE_PATIENT_UNREACHABLE_TASK - Create patient unreachable task in EHR */
  MANUAL_TASK_TYPE_EHR_CREATE_PATIENT_UNREACHABLE_TASK = 23,
  /** MANUAL_TASK_TYPE_EHR_CREATE_INSURANCE_MEDICATION_UPDATE_TASK - Create insurance medication update task in EHR */
  MANUAL_TASK_TYPE_EHR_CREATE_INSURANCE_MEDICATION_UPDATE_TASK = 24,
  /** MANUAL_TASK_TYPE_VERIFY_NEGATIVE_CALL_COUNT - Verify negative/failed call count threshold */
  MANUAL_TASK_TYPE_VERIFY_NEGATIVE_CALL_COUNT = 25,
  /** MANUAL_TASK_TYPE_FETCH_ALTERNATE_CALLING_NUMBER - Fetch an alternate calling number for the case */
  MANUAL_TASK_TYPE_FETCH_ALTERNATE_CALLING_NUMBER = 26,
  /** MANUAL_TASK_TYPE_REFILL_MED_ALLERGY_CHANGE - Refill: new medication or allergy reported on the call (PSS9) */
  MANUAL_TASK_TYPE_REFILL_MED_ALLERGY_CHANGE = 27,
  /** MANUAL_TASK_TYPE_REFILL_INSURANCE_CHANGED - Refill: patient said their insurance has changed (PSS13) */
  MANUAL_TASK_TYPE_REFILL_INSURANCE_CHANGED = 28,
  /** MANUAL_TASK_TYPE_REFILL_DECLINED_AI - Refill: patient declined calls from the AI agent (PSS14) */
  MANUAL_TASK_TYPE_REFILL_DECLINED_AI = 29,
  /** MANUAL_TASK_TYPE_REFILL_SAFE_RETURNS - Refill: Safe Returns enrollment follow-up (PSS12) */
  MANUAL_TASK_TYPE_REFILL_SAFE_RETURNS = 30,
  /** MANUAL_TASK_TYPE_REFILL_NO_CONTACT - Refill: no contact after the last call attempt (NR2) */
  MANUAL_TASK_TYPE_REFILL_NO_CONTACT = 31,
  /** MANUAL_TASK_TYPE_REFILL_DOSE_DATE_MISMATCH - Refill: stated dose date differs from the refill date by 10 days or less (pharmacist) */
  MANUAL_TASK_TYPE_REFILL_DOSE_DATE_MISMATCH = 32,
  /** MANUAL_TASK_TYPE_REFILL_PROGRESS_NOTE - Refill: a CareTend progress note could not be written; enter it by hand (PSS) */
  MANUAL_TASK_TYPE_REFILL_PROGRESS_NOTE = 33,
  /** MANUAL_TASK_TYPE_MARK_READY_TO_FILL - Refill: mark the new CareTend delivery ticket Ready to Fill (PSS) */
  MANUAL_TASK_TYPE_MARK_READY_TO_FILL = 34,
  /** MANUAL_TASK_TYPE_REFILL_DELIVERY_TICKET_FAILED - Refill: a CareTend delivery ticket could not be created or recorded; a PSS creates/records it by hand */
  MANUAL_TASK_TYPE_REFILL_DELIVERY_TICKET_FAILED = 35,
}

/** ManualTaskStatus represents the status of a manual task. */
export enum ManualTaskStatus {
  MANUAL_TASK_STATUS_UNSPECIFIED = 0,
  /** MANUAL_TASK_STATUS_PENDING - Task created, awaiting action */
  MANUAL_TASK_STATUS_PENDING = 1,
  /** MANUAL_TASK_STATUS_STARTED - Task picked up by a user */
  MANUAL_TASK_STATUS_STARTED = 2,
  /** MANUAL_TASK_STATUS_COMPLETED - Task finished successfully (terminal) */
  MANUAL_TASK_STATUS_COMPLETED = 3,
  /** MANUAL_TASK_STATUS_CANCELLED - Task cancelled (terminal) */
  MANUAL_TASK_STATUS_CANCELLED = 4,
}

/** ManualTaskSignals holds Temporal signal names for task status transitions. */
export interface ManualTaskSignals {
  on_started?: string | undefined;
  on_completed?: string | undefined;
  on_cancelled?: string | undefined;
}

/** ManualTaskOutput captures the output/result of a manual task completion. */
export interface ManualTaskOutput {
  status?: string | undefined;
  decision?: string | undefined;
  call_id?: string | undefined;
  notes?: string | undefined;
  reason?: string | undefined;
  data?: { [key: string]: any } | undefined;
}

/** ManualTask represents a manual task that requires human intervention. */
export interface ManualTask {
  id?: string | undefined;
  type?: ManualTaskType | undefined;
  status?: ManualTaskStatus | undefined;
  previous_status?: ManualTaskStatus | undefined;
  version?: number | undefined;
  /** Assignment */
  user_id?: string | undefined;
  assigned_by_user_id?: string | undefined;
  auto_assigned?: boolean | undefined;
  /** References */
  case_record_id?: string | undefined;
  organization_id?: string | undefined;
  program_id?: string | undefined;
  workflow_id?: string | undefined;
  workflow_run_id?: string | undefined;
  /** Task configuration */
  priority?: number | undefined;
  signals?: ManualTaskSignals | undefined;
  metadata?: { [key: string]: any } | undefined;
  /** Time limits */
  start_before?: string | undefined;
  deadline?: string | undefined;
  start_after?: string | undefined;
  /** Escalation */
  escalation_user_ids?: string[] | undefined;
  escalation_level?: number | undefined;
  escalated_at?: string | undefined;
  /** Completion tracking */
  started_at?: string | undefined;
  completed_at?: string | undefined;
  completed_by_id?: string | undefined;
  output?: ManualTaskOutput | undefined;
  /** Timestamps */
  created_at?: string | undefined;
  updated_at?: string | undefined;
  /** Free-text description shown on the task card. May contain PHI: never log it. */
  description?: string | undefined;
}

/** CreateManualTaskRequest represents the request to create a manual task. */
export interface CreateManualTaskRequest {
  organization_id?: string | undefined;
  user_id?: string | undefined;
  type?: ManualTaskType | undefined;
  case_record_id?: string | undefined;
  program_id?: string | undefined;
  workflow_id?: string | undefined;
  workflow_run_id?: string | undefined;
  priority?: number | undefined;
  signals?: ManualTaskSignals | undefined;
  metadata?: { [key: string]: any } | undefined;
  start_before?: string | undefined;
  deadline?: string | undefined;
  escalation_user_ids?: string[] | undefined;
  assigned_by_user_id?: string | undefined;
  auto_assigned?: boolean | undefined;
  start_after?: string | undefined;
  description?: string | undefined;
}

/** CreateManualTaskResponse represents the response for creating a manual task. */
export interface CreateManualTaskResponse {
  manual_task?: ManualTask | undefined;
}

/** GetManualTaskRequest represents the request to get a manual task. */
export interface GetManualTaskRequest {
  organization_id?: string | undefined;
  user_id?: string | undefined;
  manual_task_id?: string | undefined;
}

/** GetManualTaskResponse represents the response for getting a manual task. */
export interface GetManualTaskResponse {
  manual_task?: ManualTask | undefined;
}

/** ListManualTasksRequest represents the request to list manual tasks. */
export interface ListManualTasksRequest {
  organization_id?: string | undefined;
  user_id?: string | undefined;
  case_record_id?: string | undefined;
  type?: ManualTaskType | undefined;
  status?: ManualTaskStatus | undefined;
  program_id?: string | undefined;
  workflow_id?: string | undefined;
  limit?: number | undefined;
  start_after_id?: string | undefined;
}

/** ListManualTasksResponse represents the response for listing manual tasks. */
export interface ListManualTasksResponse {
  manual_tasks?: ManualTask[] | undefined;
  /**
   * Cursor for fetching the next page of results. Empty if no more results.
   * Use this value as start_after_id in the next request.
   */
  next_cursor?: string | undefined;
}

/** UpdateManualTaskRequest represents the request to update a manual task. */
export interface UpdateManualTaskRequest {
  organization_id?: string | undefined;
  manual_task_id?: string | undefined;
  /** The task's program. Must match the task's program_id (IDOR guard). */
  program_id?: string | undefined;
  status?: ManualTaskStatus | undefined;
  priority?: number | undefined;
  output?: ManualTaskOutput | undefined;
  metadata?: { [key: string]: any } | undefined;
  start_before?: string | undefined;
  deadline?: string | undefined;
  escalation_user_ids?: string[] | undefined;
  escalation_level?: number | undefined;
  start_after?: string | undefined;
  /**
   * Reassign the task to a different user (e.g. account consolidation or
   * workload rebalancing). The target user must exist and not be deleted.
   * Clears auto_assigned and stamps assigned_by_user_id from the caller.
   * The task keeps its workflow linkage (workflow_run_id, signals), so
   * completion by the new assignee still signals the Temporal workflow.
   */
  new_user_id?: string | undefined;
}

/** UpdateManualTaskResponse represents the response for updating a manual task. */
export interface UpdateManualTaskResponse {
  manual_task?: ManualTask | undefined;
}

/** DeleteManualTaskRequest represents the request to delete a manual task. */
export interface DeleteManualTaskRequest {
  organization_id?: string | undefined;
  user_id?: string | undefined;
  manual_task_id?: string | undefined;
}

/** DeleteManualTaskResponse represents the response for deleting a manual task. */
export interface DeleteManualTaskResponse {
  success?: boolean | undefined;
}

/**
 * ListMyManualTasksRequest represents the request to list the authenticated user's manual tasks.
 * User ID is determined from the authentication context.
 */
export interface ListMyManualTasksRequest {
  /** Required. The caller must be a member of this organization. */
  organization_id?: string | undefined;
  case_record_id?: string | undefined;
  type?: ManualTaskType | undefined;
  /** Any-of status filter; empty means every status. */
  statuses?: ManualTaskStatus[] | undefined;
  program_id?: string | undefined;
  workflow_id?: string | undefined;
  limit?: number | undefined;
  start_after_id?: string | undefined;
  /** Filter tasks created after this timestamp (exclusive). */
  created_after?: string | undefined;
  /** Filter tasks created before this timestamp (exclusive). */
  created_before?: string | undefined;
}

/** ListMyManualTasksResponse represents the response for listing the authenticated user's manual tasks. */
export interface ListMyManualTasksResponse {
  manual_tasks?: ManualTask[] | undefined;
  /**
   * Cursor for fetching the next page of results. Empty if no more results.
   * Use this value as start_after_id in the next request.
   */
  next_cursor?: string | undefined;
}

/**
 * CountMyManualTasksRequest represents the request to count the authenticated user's manual tasks.
 * Same filters as ListMyManualTasksRequest, without paging. User ID comes from the auth context.
 */
export interface CountMyManualTasksRequest {
  /** Required. The caller must be a member of this organization. */
  organization_id?: string | undefined;
  case_record_id?: string | undefined;
  type?: ManualTaskType | undefined;
  /** Any-of status filter; empty means every status. */
  statuses?: ManualTaskStatus[] | undefined;
  program_id?: string | undefined;
  workflow_id?: string | undefined;
  /** Filter tasks created after this timestamp (exclusive). */
  created_after?: string | undefined;
  /** Filter tasks created before this timestamp (exclusive). */
  created_before?: string | undefined;
}

/** CountMyManualTasksResponse represents the response for counting the authenticated user's manual tasks. */
export interface CountMyManualTasksResponse {
  count?: number | undefined;
}

/** ListOrganizationManualTasksRequest lists manual tasks of every assignee in one organization. */
export interface ListOrganizationManualTasksRequest {
  /** Required. The caller must be a member of this organization. */
  organization_id?: string | undefined;
  /** Any-of assignee filter; empty means every assignee. At most 100 entries. */
  user_ids?: string[] | undefined;
  /** Any-of status filter; empty means every status. */
  statuses?: ManualTaskStatus[] | undefined;
  /**
   * Programs to list; empty means every program the caller may read. A program-level caller
   * asking for a program it cannot read gets PermissionDenied. At most 100 entries.
   */
  program_ids?: string[] | undefined;
  task_id?: string | undefined;
  case_record_id?: string | undefined;
  created_after?: string | undefined;
  created_before?: string | undefined;
  limit?: number | undefined;
  start_after_id?: string | undefined;
}

/**
 * ListOrganizationManualTasksResponse returns one page of an organization's manual tasks,
 * newest first, without metadata, output, signals and description (data minimization).
 */
export interface ListOrganizationManualTasksResponse {
  manual_tasks?: ManualTask[] | undefined;
  next_cursor?: string | undefined;
}

/** ListCaseManualTasksRequest represents the request to list all manual tasks for a case record. */
export interface ListCaseManualTasksRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  type?: ManualTaskType | undefined;
  status?: ManualTaskStatus | undefined;
  limit?: number | undefined;
  start_after_id?: string | undefined;
}

/** ListCaseManualTasksResponse represents the response for listing manual tasks for a case record. */
export interface ListCaseManualTasksResponse {
  manual_tasks?: ManualTask[] | undefined;
  /**
   * Cursor for fetching the next page of results. Empty if no more results.
   * Use this value as start_after_id in the next request.
   */
  next_cursor?: string | undefined;
}

/** ManualTaskService provides CRUD operations for manual tasks within an organization. */
export interface ManualTaskService {
  /** CreateManualTask creates a new manual task for a user. */
  createManualTask(request: CreateManualTaskRequest): Promise<CreateManualTaskResponse>;
  /** GetManualTask retrieves a manual task by its ID. */
  getManualTask(request: GetManualTaskRequest): Promise<GetManualTaskResponse>;
  /** ListManualTasks lists manual tasks with optional filtering. */
  listManualTasks(request: ListManualTasksRequest): Promise<ListManualTasksResponse>;
  /**
   * UpdateManualTask updates an existing manual task in a program. Program-level so program
   * roles (Case Manager, Program Admin, Program Manager) can be granted
   * manual_task:update:program; Org Admins and system admins reach it through all:all.
   */
  updateManualTask(request: UpdateManualTaskRequest): Promise<UpdateManualTaskResponse>;
  /**
   * ListMyManualTasks lists manual tasks assigned to the authenticated user.
   * User ID is determined from the authentication context.
   */
  listMyManualTasks(request: ListMyManualTasksRequest): Promise<ListMyManualTasksResponse>;
  /**
   * CountMyManualTasks counts the authenticated user's manual tasks in one organization,
   * with the same filters as ListMyManualTasks. Feeds the sidebar's open-task pill.
   */
  countMyManualTasks(request: CountMyManualTasksRequest): Promise<CountMyManualTasksResponse>;
  /**
   * ListOrganizationManualTasks lists manual tasks of every assignee across the programs of
   * an organization the caller may read (All Tasks page, JNJ-293).
   */
  listOrganizationManualTasks(
    request: ListOrganizationManualTasksRequest,
  ): Promise<ListOrganizationManualTasksResponse>;
  /**
   * ListCaseManualTasks lists all manual tasks for a case record.
   * This endpoint is scoped to the case record, not a specific user.
   */
  listCaseManualTasks(request: ListCaseManualTasksRequest): Promise<ListCaseManualTasksResponse>;
  /** DeleteManualTask deletes a manual task (soft delete). */
  deleteManualTask(request: DeleteManualTaskRequest): Promise<DeleteManualTaskResponse>;
}
